WL.registerComponent('rotate', {
    enabled: {type: WL.Type.Bool, default: true},
    target: {type: WL.Type.Object},
}, {
    init: function() {
        console.log('init() with param', this.param);
    },
    start: function() {
        console.log('start() with param', this.param);
    },
    update: function(dt) {
        if(this.enabled){
            this.object.rotateAxisAngleDeg([0, 1, 0], dt*90);
        }
        
    },
});
